import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import ReceiptIcon from 'src/assets/images/icons/receipt-alt.svg';
import { TableTab } from 'src/presentations/components/organisms/analytics/table/useTable';
import { useFormContext } from 'react-hook-form';
import { useDownloadTemplate } from 'src/presentations/components/organisms/analytics/useAnalytics';
import { sanitizeFormValues } from 'src/presentations/components/organisms/analytics/utils/sanitizeFormValues';
import { useDispatch } from 'react-redux';
import { downloadStarted } from 'src/infra/stores/reducer/sseSlice';

const StyledMenu = styled(Menu)({
  '& .MuiMenu-paper': {
    borderRadius: '8px!important',
    width: '200px',
  },
});

interface IDownloadMenuProps {
  moreActionEl: HTMLButtonElement | null;
  onCloseMoreAction: () => void;
  tableTab: TableTab;
  otherProps?: Record<string, any>;
  customFileName?: string;
  pageSize?: number;
}

export const DownloadMenu = (props: IDownloadMenuProps) => {
  const { moreActionEl, onCloseMoreAction, tableTab, customFileName, otherProps, pageSize } = props;
  const { watch } = useFormContext();
  const { name, description, ...formValues } = watch();

  const fileName = name || customFileName;

  // Sanitize form values to convert empty strings to null for backend compatibility
  const sanitizedFormValues = sanitizeFormValues(formValues);

  const downloadProps = {
    filtersRequest: sanitizedFormValues,
    ...otherProps,
  };

  const { download } = useDownloadTemplate(tableTab, fileName, downloadProps, pageSize);

  const dispatch = useDispatch();

  const handleDownload = async (type: 'CSV' | 'EXCEL') => {
    try {
      dispatch(downloadStarted(type));
      await download(type);

      onCloseMoreAction();
    } catch (error) {
      console.error('Download error:', error);
    }
  };

  return (
    <>
      <StyledMenu
        open={!!moreActionEl}
        anchorEl={moreActionEl}
        onClose={onCloseMoreAction}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem>
          <ListItemIcon>
            <img src={ReceiptIcon} alt='ReceiptIcon' />
          </ListItemIcon>
          <ListItemText>
            <button onClick={() => handleDownload('CSV')}> Download CSV</button>
          </ListItemText>
        </MenuItem>
      </StyledMenu>
    </>
  );
};
